<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="12">
                            <common-page-btn @verify="$refs.colFormRef.show()"></common-page-btn>
                        </a-col>
                        <a-col span="12">
                            <a-row type="flex" justify="end" :gutter="3">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                        @on-clear="doRefresh" placeholder="关键词查询"></a-input>
                                </a-col>
                                <a-col span="6">
                                    <a-date-picker v-model="param.date" :locale="locale" allowClear @change="doRefresh"
                                        format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="领取日期" />
                                </a-col>
                                <a-col span="10">
                                    <choose-store v-model="param.storeId" @change="doRefresh"></choose-store>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="id" :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">

                    <template slot-scope="row" slot="state">
                        <a-tag color="red" v-if="row.state == 0">未核销</a-tag>
                        <a-tag color="green" v-else>已核销</a-tag>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" size="small"
                    @showSizeChange="setLimit" :current="data.current" :show-total="() => `共计 ${data.total} 条数据`" />
            </a-col>
        </a-row>
        <a-back-top />
        <guobu-verify ref="colFormRef" @success="doRefresh()"></guobu-verify>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import utils from '@/common/utils';
import chooseStore from "@/components/choose-store.vue";
import guobuVerify from "./components/guobu-verify.vue";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
export default {
    components: {
        chooseStore,
        guobuVerify,
        locale
    },
    data() {
        return {
            data: [],
            loading: false,
            locale,
            param: {
                page: 1,
                date: '',
                limit: 20,
                keyword: '',
                storeId: ''
            },
            keys: [
                { title: '编号', dataIndex: 'code', align: 'left', width: 200, ellipsis: true },
                { title: '所属商户', dataIndex: 'storeName', align: 'left', ellipsis: true },
                { title: '核销状态', scopedSlots: { customRender: 'state' }, width: 120, align: 'center', ellipsis: true },
                { title: '领取人', dataIndex: 'userName', width: 160, align: 'center', ellipsis: true },
                { title: '领取时间', dataIndex: 'createTime', width: 200, ellipsis: true },
                { title: '核销人', dataIndex: 'actionUser', width: 160, ellipsis: true },
                { title: '核销时间', dataIndex: 'actionTime', width: 200, ellipsis: true },
                // { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/guobu/list', this.param)
                .then(ret => {
                    console.log(ret)
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
